/**
 * 곡 중간에 박자가 바뀌는 마디 (2026-10). 악보를 만들 때 표현할 방법이 없어 가사 칸에
 * '(2/4박자)', '3/4박자', '(3/4)', '5/4박' 처럼 적어 둔 것을 읽어서
 *  - 가사에서는 지우고 (글자 위치 = 박자 위치라서 같은 길이의 빈칸으로 바꿈)
 *  - 그 마디 길이를 박자에 맞게 줄이거나 늘린다 (4/4 곡의 2/4 마디 → 절반 시간).
 * 적어 둔 마디에만 적용한다 (대부분의 악보가 바뀐 마디마다 적어 둠).
 */
const RE_WORD = /(?:\(\s*(?:intro\s*:\s*)?)?(\d{1,2})\s*\/\s*(2|4|8|16)\s*박자?\s*\)?/i;
const RE_PAREN = /\(\s*(\d{1,2})\s*\/\s*(2|4|8|16)\s*\)/;

/** 곡의 기본 박자를 4분음표 몇 개 길이로 (4/4 → 4, 3/4 → 3, 6/8 → 3, 12/8 → 6) */
export const quarterBeats = (beat?: string | null) => {
  const m = (beat || "4/4").match(/(\d+)\s*\/\s*(\d+)/);
  if (!m) return 4;
  const v = (Number(m[1]) * 4) / Number(m[2]);
  return v > 0 ? v : 4;
};

export interface IMeter {
  lyrics: string; // 표시를 지운 가사
  meter?: string; // '2/4' (곡 기본 박자와 다를 때만)
  scale: number; // 이 마디 길이 / 보통 마디 길이
}

export const readMeter = (lyrics: string | null | undefined, songQuarters: number): IMeter => {
  const text = lyrics || "";
  const m = text.match(RE_WORD) || text.match(RE_PAREN);
  if (!m || m.index === undefined) return { lyrics: text, scale: 1 };
  const num = Number(m[1]);
  const den = Number(m[2]);
  if (!num || num > 16) return { lyrics: text, scale: 1 };
  const cleaned = text.slice(0, m.index) + " ".repeat(m[0].length) + text.slice(m.index + m[0].length);
  const scale = (num * 4) / den / songQuarters;
  if (Math.abs(scale - 1) < 0.01) return { lyrics: cleaned, scale: 1 };
  return { lyrics: cleaned, meter: `${num}/${den}`, scale };
};
